var slides = $('.staro075 section').length,
	activeSlide = 1,
	nextSlide = 2,
	tl = new TimelineMax(),
	winH,
	cover = true,
	animations = [];

$(window).on('load resize', scaleSections);

$(window).on('load', function(){
	TweenMax.to('.preloader', 0.5, {opacity:0, display:'none', ease: Power2.easeOut});
    TweenMax.fromTo(".staro075-cover .container", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0});
});

animations[1] = new TimelineMax({paused: true})
	.staggerFromTo(".section1 .container-fluid", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.5)
	.fromTo(".section1-bottle", 0.75, {ease: Power4.easeOut, opacity:0, x:'100%' }, {opacity:1, x: '0%'}, '-=0.5');
animations[2] = new TimelineMax({paused: true})
	.staggerFromTo(".section2 .container-fluid", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.5);
animations[3] = new TimelineMax({paused: true})
	.staggerFromTo(".section3 p", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.25);
animations[4] = new TimelineMax({paused: true})
	.staggerFromTo(".section4 h2, .section4 p", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.25);
animations[5] = new TimelineMax({paused: true})
	.staggerFromTo(".section5 p", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.25);
animations[6] = new TimelineMax({paused: true})
	.staggerFromTo(".section6 p", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.25);
animations[7] = new TimelineMax({paused: true})
	.staggerFromTo(".section7 h2, .section7 div, .section7 p", 0.5, {ease: Power2.easeOut, opacity:0, y:20, delay:1 }, {opacity:1, y: 0}, 0.25);

function scaleSections() {
	if (window.matchMedia("(min-width: 768px)").matches) {
		winH = $(window).outerHeight();
		$('.staro075 section').each(function(){
			$(this).removeAttr('style').height(winH).css({'padding-top':$('.navbar.navbar-default').outerHeight()});
		}).promise().done( function(){
			tl.set('.staro075', { y: -(winH*(activeSlide-1))});
		} );
	} else {
		winH = $(window).outerHeight();
		if ( $("input, textarea").is(":focus") ){

		} else {
			$('.staro075 section').each(function(){
				$(this).removeAttr('style').css({'padding-top':$('.navbar.navbar-default').outerHeight(),'min-height':winH});
			}).promise().done( function(){
				tl.set('.staro075', { y: -(winH*(activeSlide-1))});
			});
		}
	}
}

function gotoPage(next, current){
	if (!tl.isActive()) {
		if (current) {
			animations[current].reverse();
		}
		activeSlide = next;
		//console.log(activeSlide);
		tl.to(".staro075", 1, {ease: Power2.easeInOut, y: -(winH*(activeSlide-1)), onComplete:function(){
			animations[activeSlide].play();
		}});
	}
}

$(window).on('mousewheel swipe', function(event, touch) {
	if (event.type == 'mousewheel' && event.originalEvent.wheelDelta >= 0) {
		var direction = 1;
	} else if (event.type == 'mousewheel' && event.originalEvent.wheelDelta <= 0) {
		var direction = 0;
	} else if (event.type == 'swipe' && touch.direction == 'up') {
		var direction = 0;
	} else if (event.type == 'swipe' && touch.direction == 'down') {
		var direction = 1;
	} else {
		var direction = undefined;
	}

	//if (window.matchMedia("(min-width: 768px)").matches) {
		if (direction == 1) {
			if (!tl.isActive() && activeSlide > 1) {
				nextSlide = activeSlide - 1;
				gotoPage(nextSlide, activeSlide);
			}
		} else if (direction == 0) {
			if (!tl.isActive() && activeSlide < slides) {
				if (cover) {
					cover = false;
					tl.to(".staro075-cover", 1, {ease: Power2.easeInOut, y: '-100%', onComplete: function(){
						animations[activeSlide].play();
					}});
				} else {
					nextSlide = activeSlide + 1;
					gotoPage(nextSlide, activeSlide);
				}
			}
		}
	//}
});

$(document).on('ready', function () {

    $('.staro075-play-button').on('click', function(){
        $('#video-player').attr('src','https://www.youtube-nocookie.com/embed/'+$(this).data('video')+'?showinfo=0&autoplay=1&rel=0&controls=1');
        $('#video-overlay').fadeIn();
		if (window.ga) {
			ga('send', 'event', 'Staro 750ml','Video',$(this).data('video'));
		}
    });

    $('.contest').on('click', function(){
		(window.dataLayer || []).push({ 'event': 'lta-open-form' });
		cover = false;
		activeSlide = 5;
		tl.set(".staro075", {y: -(winH*(activeSlide-1))})
		.to(".staro075-cover", 1, {ease: Power2.easeInOut, y: '-100%', onComplete: function(){
			$('#formModal').on('shown.bs.modal',  function(){ animations[activeSlide].play(); }).modal({
				backdrop:'static',
				keyboard: false,
				show:true
			});
		}});
    });

	$('#participa').on('click', function(){

	});


	$('#participa').on('click', function(){
		(window.dataLayer || []).push({ 'event': 'lta-open-form' });
	});

	$('#bringo').on('click', function(){
		(window.dataLayer || []).push({ 'event': 'lta-open-form' });
		if (window.ga) {
			ga('send', 'event', 'Staro 750ml','Bringo','Click');
		}
	});

    $('#video-close').on('click', function(){
        $('#video-player').attr('src','');
        $('#video-overlay').fadeOut();
    });

	$('#mesaj').on('keyup', function(){
		$('#counter').text('Mai ai '+(160-$('#mesaj').val().length)+' caractere');
	});
	
	var formRegister = new AjaxPostman(
			'form.staro075-form',
			function() {
				(window.dataLayer || []).push({ 'event': 'lta-success' });
				if (window.ga) {
					ga('send', 'pageview', '/la-tine-acasa/success');
					//ga('send', 'event', 'Staro 750ml','Register','Success');
				}
				$("form.staro075-form").slideUp();
				$(".staro075-confirmation").slideDown();
			}
	);

	(function () {
		var userAgent = navigator.userAgent || navigator.vendor || window.opera;

		if (/android/i.test(userAgent)) {
			$('#bringo').attr('href','https://play.google.com/store/apps/details?id=ro.ascendnet.bringo');
		}

		// iOS detection from: http://stackoverflow.com/a/9039885/177710
		if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
			$('#bringo').attr('href','https://geo.itunes.apple.com/ro/app/bringo-delivery/id1027280773?mt=8');
		}

	})();

});
